
    <ng-container *ngIf="shouldShowErrors()">
      <span class="validation-error" *ngFor="let error of listOfErrors()">{{error}}</span>
    </ng-container>
  